import React from 'react';
import { FadeIn } from './FadeIn';
export function PsychologySection() {
  return <section className="py-24 px-6 bg-dark-card border-y border-gold/10 relative" data-id="element-189">
      <div className="max-w-3xl mx-auto" data-id="element-190">
        <FadeIn data-id="element-191">
          <div className="flex justify-center mb-8" data-id="element-192">
            <div className="inline-flex items-center gap-3 bg-dark border border-gold/30 rounded-full px-5 py-2 shadow-[0_0_20px_rgba(212,175,55,0.1)]" data-id="element-193">
              <span className="text-gold text-sm tracking-wide" aria-label="5 star rating" data-id="element-194">
                ★★★★★
              </span>
              <span className="text-gray-300 text-xs md:text-sm tracking-wide" data-id="element-195">
                <span className="text-gold font-bold" data-id="element-196">4.9/5</span> Average
                Satisfaction Rating
                <span className="hidden sm:inline" data-id="element-197">
                  {' '}
                  · Based on 18,000+ Men
                </span>
              </span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.05} data-id="element-198">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-10 text-center" data-id="element-199">
            If you are reading this, you know exactly what I’m talking about.
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-200">
          <p className="text-lg text-gray-300 mb-10 leading-relaxed" data-id="element-201">
            If you are here, it’s because you know something has changed. Maybe
            it started as an{' '}
            <span className="text-white font-semibold" data-id="element-202">isolated incident</span>.
            A moment of stress, an extra bit of fatigue... and suddenly,{' '}
            <span className="text-white font-bold uppercase tracking-wide" data-id="element-203">
              YOU FELT LIMP
            </span>
            .
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-204">
          <div className="border-l-4 border-gold bg-dark-lighter p-8 mb-10 shadow-lg relative" data-id="element-205">
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-gold/5 to-transparent pointer-events-none" data-id="element-206"></div>
            <p className="text-xl text-white font-serif italic leading-relaxed relative z-10" data-id="element-207">
              That uncomfortable silence in the room. That look from your
              partner or date you try not to see. But the worst part is not
              that. The worst part is the thought that haunts you the next day:{' '}
              <span className="not-italic font-bold text-gold" data-id="element-208">
                Will it happen to me again?
              </span>
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-209">
          <p className="text-lg text-gray-300 mb-16 leading-relaxed" data-id="element-210">
            <span className="text-white font-semibold" data-id="element-211">
              Performance anxiety
            </span>{' '}
            is a vicious cycle. The more you worry, the more cortisol you
            produce. And cortisol is the number one killer of your erection. You
            feel less of a man. You feel you’ve lost control of your own body.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-212">
          <div className="text-center" data-id="element-213">
            <h3 className="text-2xl md:text-4xl font-serif font-bold text-gold leading-tight" data-id="element-214">
              "I have news for you: It’s not your fault. But it is your
              responsibility to fix it."
            </h3>
          </div>
        </FadeIn>
      </div>
    </section>;
}